module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADbSURBVHgBjZJNDoIwEIXbzkU8gq5JiEfwCFyCnx24IoGF3sC49BRqAmyNN3DpKahvSGoqtg0vmQx5zJfpTCsElOf5SixUmqZrzpI/lFIPRFLX9TkEoUGFVI7juKFhGN5RFLF/jOP41XXdMwRprau2bS/EZt/39xBsQ03T7Nkj89MHF0WRIB1saJpxfqQsy0opZcUzo1giTogE0M/8NAftzoidC2Ip4RA6fk9CRK6S/472IpBvwrMw8kG8iNC2yQcJx8w2TCEoBEtAWxhXH2TLXBU/uckwD3eJTO0HxjeqGHlIyeQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/button/btnClose.png
// module id = WxFx
// module chunks = 1